import {
  GET_LISTING_SPECIFIC_FIELDS_DATA_START,
  GET_LISTING_SPECIFIC_FIELDS_DATA_SUCCESS,
  GET_LISTING_SPECIFIC_FIELDS_DATA_ERROR
} from '../constants';
import { getListingSpecSettings as query } from '../lib/graphql';

export function getSpecificSettings(id) {

  return async (dispatch, getState, { client }) => {

    dispatch({
      type: GET_LISTING_SPECIFIC_FIELDS_DATA_START,
    });

    try {
      // Send Request to get listing data
      const { data } = await client.query({
        query,
        variables: { id },
        fetchPolicy: 'network-only'
      });

      if (data?.getListingSpecSettings) {
        dispatch({
          type: GET_LISTING_SPECIFIC_FIELDS_DATA_SUCCESS,
          settingsData: data.getListingSpecSettings,
        });
      } else {
        dispatch({
          type: GET_LISTING_SPECIFIC_FIELDS_DATA_ERROR,
        });
      }
    } catch (error) {
      dispatch({
        type: GET_LISTING_SPECIFIC_FIELDS_DATA_ERROR,
        payload: {
          error
        }
      });
      return false;
    }

    return true;
  };
}
